export default __webpack_public_path__ + "static/media/sk.fd952262.svg";